import { render, staticRenderFns } from "./MovieTicketDialog.vue?vue&type=template&id=4d1a580a&scoped=true&"
import script from "./MovieTicketDialog.vue?vue&type=script&lang=js&"
export * from "./MovieTicketDialog.vue?vue&type=script&lang=js&"
import style0 from "./MovieTicketDialog.vue?vue&type=style&index=0&id=4d1a580a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1a580a",
  null
  
)

export default component.exports